import {ApiBase} from "@/src/model/ApiBase";
import {WORKSPACE_API_TYPE} from "@/src/model/apiTypes";

export class WorkspaceApi extends ApiBase {
    async [WORKSPACE_API_TYPE.GET_WORKSPACES]() {
        return await this.httpGet('workspaces/')
    }

    async [WORKSPACE_API_TYPE.ADD_WORKSPACE](data) {
        return await this.httpPost('workspaces/', data)
    }

    async [WORKSPACE_API_TYPE.UPDATE_WORKSPACE]({spaceId, data}) {
        return await this.httpPut(`workspaces/${spaceId}/`, data)
    }

    async [WORKSPACE_API_TYPE.DELETE_WORKSPACE]({spaceId}) {
        return await this.httpDelete(`workspaces/${spaceId}/`)
    }

    async [WORKSPACE_API_TYPE.GET_PERMISSIONS]({spaceId}) {
        return await this.httpGet(`workspaces/${spaceId}/permissions/`)
    }

    async [WORKSPACE_API_TYPE.GET_USER_PERMISSIONS]({spaceId}) {
        return await this.httpGet(`workspaces/${spaceId}/permissions/user/`)
    }

    async [WORKSPACE_API_TYPE.UPDATE_PERMISSIONS]({spaceId, data}) {
        return await this.httpPost(`workspaces/${spaceId}/permissions/`, data)
    }

    async [WORKSPACE_API_TYPE.SEARCH]({query}) {
        return await this.httpGet(`search/?query=${query}`)
    }
}

